import { createMemo, JSX, type ParentComponent } from 'solid-js'

interface Props {
  style?: JSX.CSSProperties,
}

const MiniMapContainer: ParentComponent<Props> = (props) => {
  const style = createMemo<JSX.CSSProperties>(() => {
    // const { size } = props
    return {
      // width: `${size * stateWidth()}px`,
      // height: `${size * stateHeight()}px`,
      padding: '0.5rem',
      // padding: '0px',
      // margin: '0px',
      // background: 'black',
      background: 'rgb(0, 0, 0, 0.25)',
      color: 'white',
      // position: 'absolute',
      position: 'fixed',
      bottom: '0px',
      left: '0px',
      // width: '100%',
      // height: '100%',
      'z-index': 100,
      ...props.style,
    }
  })

  return <div class="mini-map-container" style={style()}>{props.children}</div>
}

export default MiniMapContainer